import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _isEmpty from 'lodash/isEmpty';
import { Menu } from 'antd';
import './searchList.css';
import { isEmpty } from '../../utils/helper';
import { NO_OP } from '../../constants/Constants';
class SearchList extends Component {
  constructor() {
    super(...arguments);
    this.handleMenuClick = (menu, item) => {
      const {
        title,
        key
      } = item;
      const {
        onSelect
      } = this.props;
      onSelect({
        item: menu,
        title,
        key
      });
    };
    this.getBackText = () => {
      const {
        list
      } = this.props;
      const str = [];
      list.forEach((item, i) => {
        const {
          title
        } = item;
        if (i === list.length - 1 && str.length > 0 && title) {
          str.push('and');
        }
        if (title) {
          str.push(title);
        }
      });
      return str.join(' ');
    };
    this.renderBackButton = () => {
      const {
        onBackClick,
        displayInfo,
        customBackText
      } = this.props;
      const backText = isEmpty(customBackText) ? "".concat(__('Back to'), " ").concat(this.getBackText()) : customBackText;
      return /*#__PURE__*/React.createElement(Menu.Item, {
        className: "more back-button"
      }, displayInfo && /*#__PURE__*/React.createElement("p", null, displayInfo), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "action-button",
        onClick: onBackClick
      }, backText));
    };
    this.renderMoreButton = (title, i) => {
      const {
        onShowMoreClick,
        displayInfo,
        customMoreText
      } = this.props;
      const moreText = isEmpty(customMoreText) ? "".concat(__('Browse all'), " ").concat(title) : customMoreText;
      return /*#__PURE__*/React.createElement(Menu.Item, {
        className: "more more-button"
      }, displayInfo && /*#__PURE__*/React.createElement("p", null, displayInfo), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "action-button",
        onClick: () => onShowMoreClick(i)
      }, moreText));
    };
    this.renderMandatoryContent = () => {
      const {
        globalSearchMandatoryContent
      } = this.props;
      if (!isEmpty(globalSearchMandatoryContent)) {
        return /*#__PURE__*/React.createElement(Menu.Item, {
          className: "more mandatory-content"
        }, globalSearchMandatoryContent());
      }
      return null;
    };
    this.renderItem = (item, i) => {
      const {
        title,
        values
      } = item;
      const {
        activeIndex,
        formatter,
        isListEmpty
      } = this.props;
      if ((activeIndex === i || activeIndex === -1) && !_isEmpty(values)) {
        const showBack = activeIndex > -1;
        const data = showBack ? [...item.values] : [...item.values].slice(0, 5);
        const showMore = item.values.length > 5;
        return /*#__PURE__*/React.createElement(Menu.ItemGroup, {
          key: "group-title-".concat(i),
          title: title,
          className: "group-title"
        }, data && data.map(menu => /*#__PURE__*/React.createElement(Menu.Item, {
          key: menu.value,
          onClick: () => this.handleMenuClick(menu, item)
        }, formatter ? formatter(menu) : menu.label)), !showBack && showMore && !isListEmpty && this.renderMoreButton(title, i));
      }
      return null;
    };
  }
  render() {
    const {
      list,
      activeIndex,
      isListEmpty
    } = this.props;
    if (_isEmpty(list)) {
      return null;
    }
    const showBack = activeIndex > -1;
    return /*#__PURE__*/React.createElement(Menu, {
      className: "search-menu search-list"
    }, list && list.map((item, index) => this.renderItem(item, index)), showBack && !isListEmpty && this.renderBackButton(), this.renderMandatoryContent());
  }
}
SearchList.defaultProps = {
  list: [],
  formatter: null,
  activeIndex: -1,
  displayInfo: '',
  globalSearchMandatoryContent: NO_OP,
  onShowMoreClick: NO_OP,
  onSelect: NO_OP,
  onBackClick: NO_OP,
  isListEmpty: false,
  customBackText: '',
  customMoreText: ''
};
SearchList.propTypes = {
  displayInfo: PropTypes.any,
  globalSearchMandatoryContent: PropTypes.func,
  list: PropTypes.array,
  isListEmpty: PropTypes.bool,
  formatter: PropTypes.func,
  activeIndex: PropTypes.number,
  onShowMoreClick: PropTypes.func,
  onSelect: PropTypes.func,
  onBackClick: PropTypes.func,
  customBackText: PropTypes.string,
  customMoreText: PropTypes.string
};
export default SearchList;